/**
 * MED-1349 QA round 4: rules for the Edit Event Date/Time dialog.
 */
import { END_AFTER_START_ERROR } from '../../../../utils/sessionEndTime';

/** The event's saved length (end minus start), or null when there is none. */
export function eventLengthMs(start: string | null, end: string | null): number | null {
  if (!start || !end) return null;
  const length = new Date(end).getTime() - new Date(start).getTime();
  return length > 0 ? length : null;
}

/**
 * The end after the start is set or changed (ruling 2). The end always
 * follows the start:
 * - with a current end after the old start, it keeps that length;
 * - otherwise it is the new start plus the usual length;
 * - with no usual length it stays as it is (empty for a new event).
 * A cleared start leaves the end as it is.
 */
export function endForNewStart(
  oldStart: Date | null,
  oldEnd: Date | null,
  newStart: Date | null,
  usualLengthMs: number | null,
): Date | null {
  if (!newStart) return oldEnd;
  if (oldStart && oldEnd && oldEnd.getTime() > oldStart.getTime()) {
    return new Date(newStart.getTime() + (oldEnd.getTime() - oldStart.getTime()));
  }
  if (usualLengthMs !== null) return new Date(newStart.getTime() + usualLengthMs);
  return oldEnd;
}

/** Inline error for the End field. Null when the end is empty or after the start. */
export function endAfterStartError(start: Date | null, end: Date | null): string | null {
  if (!start || !end) return null;
  return end.getTime() <= start.getTime() ? END_AFTER_START_ERROR : null;
}
